export default "__VITE_ASSET__DMdD5B0Z__"